import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Pagination from "@material-ui/lab/Pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  withStyles,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { DebounceInput } from "react-debounce-input";
import loader from "../../images/Spin-1s-107px.gif";
import GroupListDashboardContainer from './GroupListDashboardContainer';
import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
  getAllCategory,
  getAllGroupsByParentAffiliateUser,
  getAffiliateUser,
} from "../../Actions/actions";

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#fff",
    color: "#525659",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class GroupDashboardContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      settlementDataAffiliateData: {},
      userid: localStorage.getItem("userId"),
      affiliateType: "",
      GetAffiliateUserData: "",
      rowsPerPage: 10,
      pageNumber: 1,
      searchKeyword: "",
      isLoader: false,
      sortBy: "",
      parentPartnerId: "",
      recordsAndResult : {}
    };
  }

  async componentDidMount() {
    this.setState({
      isLoader: true,
    });
    const { userid } = this.state;
    const { getAffiliateUser } = this.props;
    getAffiliateUser(userid);
    this.fetchData({ searching: false });
  }

  fetchData = (data) => {
    const {
      rowsPerPage,
      affiliateType,
      pageNumber,
      searchKeyword,
      parentPartnerId,
    } = this.state;
    this.setState({
      isLoader: true,
      pageNumber: data.searching ? data.pageNumber : pageNumber,
    });
    this.props.getAllGroupsByParentAffiliateUser({
      pageNumber: data.searching ? 1 : pageNumber,
      pageSize: rowsPerPage,
      searchKeyword: searchKeyword,
      affiliateType: affiliateType,
      parentPartnerId: parentPartnerId,
      displayMode: "partner",
    });
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.data.receiveAllGroupsByParentAffiliateUser &&
      newProps.data.receiveAllGroupsByParentAffiliateUser.code == "400" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
      });
    }
    if (
      newProps.data.receiveAllGroupsByParentAffiliateUser &&
      newProps.data.receiveAllGroupsByParentAffiliateUser.code == "200" &&
      this.state.isLoader == true
    ) {
      this.setState({
        isLoader: false,
        recordsAndResult:newProps.data.receiveAllGroupsByParentAffiliateUser
      });
    }
  }

  componentDidUpdate() {
    const { settlementRefeDataAffiliateData } = this.props.data;
    const { settlementDataAffiliateData, parentPartnerId } = this.state;
    if (parentPartnerId !== this.props.data.GetAffiliateUser.affiliateUserId) {
      this.setState(
        {
          parentPartnerId: this.props.data.GetAffiliateUser.affiliateUserId,
        },
        () => {
          if (this.props.data.GetAffiliateUser.affiliateUserId) {
            this.fetchData({ searching: false });
          }
        }
      );
    }

    if (settlementRefeDataAffiliateData !== settlementDataAffiliateData) {
      this.setState({
        settlementDataAffiliateData: settlementRefeDataAffiliateData,
        isLoader: false,
      });
    }
  }

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        pageNumber: parseInt(newPage, 10),
      },
      () => {
        this.fetchData({ searching: false });
      }
    );
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: parseInt(event.target.value, 10),
      },
      () => {
        this.fetchData({ searching: false });
      }
    );
  };

  render() {
    const { rowsPerPage, pageNumber, searchKeyword, isLoader } = this.state;
    const {
      data: {
        settlementRefeDataAffiliateData,
        receiveAllGroupsByParentAffiliateUser,
      },
    } = this.props;

    

    return (

      <div className="">
        {isLoader === true ? (
          <div className="loader">
            <img src={loader} alt="" />
          </div>
        ) : (
          ""
        )}
      
        <div className="tab-container-inner">
          <div className="breadcrumbs">
            {/* <Link to="/affiliate">List</Link> */}
            <span>List</span>
          </div>
          <div className="card-table-outer">
          <div className="table-filter">
            <h3 className="table-filter-tittle">
              {" "}
              <em className="mob-hide">Groups</em>{" "}
              <span>
                {" "}
                {receiveAllGroupsByParentAffiliateUser &&
                  receiveAllGroupsByParentAffiliateUser.result && (
                    <span>
                      ({receiveAllGroupsByParentAffiliateUser.result.totalCount}
                      )
                    </span>
                  )}{" "}
              </span>{" "}
            </h3>
            <div className="filter-form">
              <div className="input-search-outer">
                <DebounceInput
                  placeholder="Search"
                  type="search"
                  // className={className}
                  debounceTimeout={500}
                  onChange={(evet) => {
                    this.setState(
                      {
                        searchKeyword: evet.target.value,
                      },
                      () => {
                        this.fetchData({ searching: true, pageNumber: 1 });
                      }
                    );
                  }}
                  forceNotifyByEnter={false}
                  value={searchKeyword}
                />

                <SearchIcon className="p-serch-icon " />
                <SearchIcon className="p-serch-icon " />
              </div>
            </div>
          </div>
          <div className="p-table-outer groups_total_user">
            {receiveAllGroupsByParentAffiliateUser &&
            receiveAllGroupsByParentAffiliateUser.code ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <CustomTableCell>Name</CustomTableCell>
                    <CustomTableCell>SUB PARTNERS</CustomTableCell>
                    <CustomTableCell>OWNER</CustomTableCell>
                    <CustomTableCell>TOTAL USERS</CustomTableCell>
                    <CustomTableCell></CustomTableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="p-table-body">
                  {receiveAllGroupsByParentAffiliateUser.result ? (
                    receiveAllGroupsByParentAffiliateUser.result.records.map(
                      (item) => (
                        <TableRow key={item.id}>
                          <CustomTableCell>
                            <Link
                              // to="/userDetail"
                              to={`/groupsAffiliate/${item.id}`}
                            >
                              {item.name !== undefined ? item.name : "N/A"}
                            </Link>
                          </CustomTableCell>
                          <CustomTableCell>
                            {item.partnersCount}
                          </CustomTableCell>
                          <CustomTableCell>
                            {this.props.data.GetAffiliateUser.fullName}
                          </CustomTableCell>
                          <CustomTableCell>{item.enrolledUsersCount}</CustomTableCell>

                          {/* <CustomTableCell > <Link
                                                    // to="/userDetail"
                                                    to={`/groupDetail/${item.id}`}
                                                >
                                                    View
                </Link></CustomTableCell> */}
                        </TableRow>
                      )
                    )
                  ) : (
                    <TableRow className="record-notfound">
                      <CustomTableCell>Record Not found</CustomTableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            ) : (
              ""
            )}
          </div>
          <Pagination
            count={
              receiveAllGroupsByParentAffiliateUser.result &&
              receiveAllGroupsByParentAffiliateUser.result.totalCount >
                receiveAllGroupsByParentAffiliateUser.result.pageSize
                ? Math.ceil(
                    receiveAllGroupsByParentAffiliateUser.result.totalCount /
                      receiveAllGroupsByParentAffiliateUser.result.pageSize
                  )
                : 1
            }
            variant="outlined"
            shape="rounded"
            // count={settlementRefeDataAffiliateData.result && Math.round(settlementRefeDataAffiliateData.result.totalCount/settlementRefeDataAffiliateData.result.pageSize)} variant="outlined" shape="rounded"
            onChange={this.handleChangePage}
            page={pageNumber}
            className="custom-pagination"
          />
          </div>
          {/* <TablePagination
                        component="div"
                        className="pagination-table"
                        count={settlementRefeDataAffiliateData && settlementRefeDataAffiliateData.result && settlementRefeDataAffiliateData.result.totalCount ? settlementRefeDataAffiliateData.result.totalCount : 0}
                        rowsPerPage={rowsPerPage}
                        page={pageNumber}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> */}
                   
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.data,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
      getAllCategory,
      getAllGroupsByParentAffiliateUser,
      getAffiliateUser,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupDashboardContainer);
